import React from 'react';
import { twMerge } from 'tailwind-merge';
import { HERO_MOCKUP } from '../data/assets';
import { BoardMotif, TwoChairs } from './BoardMotif';
type ProductVisualProps = {
  className?: string;
  eager?: boolean;
};
type Cover = {
  vol: string;
  title: string;
  sub: string;
  band: string;
  art: 'chairs' | 'circle';
  cls: string;
};

/**
 * Visual del producto. Si hay mockup principal (data/assets.ts), lo muestra;
 * si no, arma un abanico con 3 portadas de tomo diseñadas en código
 * (horizontales, como el formato real del pack).
 */
export function ProductVisual({
  className = '',
  eager = false
}: ProductVisualProps) {
  if (HERO_MOCKUP) {
    return <img src={HERO_MOCKUP} alt="The six Gestalt Session Ready volumes lined up on a therapist's desk, with the printable experiment cards in front" width={2048} height={1360} loading={eager ? 'eager' : 'lazy'} className={twMerge('h-auto w-full rounded-2xl shadow-card', className)} data-id="element-285" data-mp="f6y8wy2p7oym" />;
  }
  const covers: Cover[] = [{
    vol: 'Volume 1 of 6',
    title: 'Here & Now',
    sub: 'Awareness experiments for opening, following and closing',
    band: 'bg-sage',
    art: 'circle',
    cls: 'left-0 top-0 -rotate-6'
  }, {
    vol: 'Volume 6 of 6',
    title: 'Group Gestalt',
    sub: 'Experiments and session plans for groups',
    band: 'bg-teal',
    art: 'circle',
    cls: 'right-0 top-[8%] rotate-[5deg]'
  }, {
    vol: 'Volume 4 of 6',
    title: 'Chair Work & Dialogue',
    sub: 'Empty-chair, two-chair and polarity experiments',
    band: 'bg-ochre',
    art: 'chairs',
    cls: 'left-[9%] bottom-0 z-10 -rotate-1'
  }];
  return <div className={`relative mx-auto aspect-[5/4] w-full max-w-[520px] ${className}`} role="img" aria-label="Three of the six volume covers: Here & Now, Group Gestalt and Chair Work & Dialogue" data-id="element-286" data-mp="2s2ynwss50xzt">
      {covers.map(c => <div key={c.title} className={`absolute aspect-[16/10] w-[78%] overflow-hidden rounded-xl border border-sand-dark bg-cream shadow-card ${c.cls}`} data-id="element-287" data-mp="xq8su7q19iqu">
          <div className={`h-1.5 w-full ${c.band}`} data-id="element-288" data-mp="32rcor668fpy4" />
          <div className="relative flex h-full flex-col p-[6%]" data-id="element-289" data-mp="36psidswtjwki">
            <span className="text-[8px] font-bold uppercase tracking-[1.4px] text-ink-muted sm:text-[10px]" data-id="element-290" data-mp="3bpx17pl793dw">
              Gestalt Session Ready · {c.vol}
            </span>
            <span className="mt-1.5 max-w-[62%] font-display text-[18px] leading-[1.05] text-sage sm:text-[26px]" data-id="element-291" data-mp="3gmx822pvia62">
              {c.title}
            </span>
            <span className="mt-1.5 max-w-[55%] border-t border-terra/60 pt-1.5 text-[8px] leading-snug text-ink-soft sm:text-[10px]" data-id="element-292" data-mp="3qfvw9jhgjyp5">
              {c.sub}
            </span>
            {c.art === 'chairs' ? <TwoChairs className="absolute bottom-[14%] right-[4%] w-[42%] text-sage" data-id="element-293" data-mp="3bfyuyhupner" /> : <BoardMotif className="absolute bottom-[12%] right-[6%] w-[32%] text-teal" data-id="element-294" data-mp="89pv7cfbau1y" />}
          </div>
        </div>)}
    </div>;
}